/*const splitArray = (_this) => {
  if($(window).width() > 800 && !$(_this).find('.list-left').length) {
    const array = $(_this).find('.faq-qa');
    const arrayLength = $(array).length;
    const middle = Math.floor(arrayLength / 2);

    const leftArray = array.splice(middle, arrayLength);
    array.splice(0, middle);

    $(_this).find('.list-right').after('<ul class="list-left"></ul>');
    $(_this).find('.list-left').append(leftArray);
  } else if ($(window).width() < 800 && $(_this).find('.list-left').length) {
    const leftContent = $(_this).find('.list-left').contents();

    $(_this).find('.list-right').prepend(leftContent);

    $(_this).find('.list-left').remove();
  }
}*/

$(document).ready(() => {
  /*$('.block-faq').each(function() {
    splitArray(this);
  });*/

  $('.faq-qa .title').click(function() {
    $(this).parents('.faq-qa').toggleClass('open');
  });
  $('.expertise-sub-articles-sidebar-toggle').click(function() {
    $(this).parents('.expertise-sub-articles-sidebar').toggleClass('open');
  });
});
/*
$(window).resize(() => {
  $('.block-faq').each(function() {
    splitArray(this);
  });
});*/
